import React, { lazy, Suspense } from "react";

const StaffManagementPage = lazy(() => import("./staff-management-page"));

const CheckInPointPage = () => (
    <Suspense fallback={null}><StaffManagementPage screen="point" /></Suspense>
);

export default CheckInPointPage;
